import { useQuery } from '@tanstack/react-query';
import { getSprintReleaseIdRelease } from '../api/sprint-api/sprint-api';
import { SprintDto } from '../api/model';

export const useReleaseSprints = (releaseId: number) => {
  const query = useQuery({
    queryKey: [`/sprint/${releaseId}/release`],
    queryFn: async () => {
      if (!releaseId) return [];
      const result = await getSprintReleaseIdRelease(releaseId);

      if (!result) return [];
      if (Array.isArray(result)) return result;

      return [result];
    },
    enabled: !!releaseId && releaseId > 0,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  // data working and processing
  const rawData = query.data || [];
  const sprints = Array.isArray(rawData) ? rawData : [];
  
  // Return all sprints for the release
  const filteredSprints = sprints;

  return {
    sprints: filteredSprints,
    isLoading: query.isLoading,
    error: query.error
  };
};